import _ from 'underscore';
import $ from 'jquery';
import { ApplicationInsights } from '@microsoft/1ds-analytics-web-js';
import { isTestEnvironment, initPDL } from '@bingads-webui-campaign/global-app-init';

export function loadOneDSAnalytics({ serverContext }) {
  // eslint-disable-next-line camelcase, no-undef
  const gpcDataSharingOptIn = typeof GPC_DataSharingOptIn !== 'undefined' ? GPC_DataSharingOptIn : undefined;

  const init1DSAnalytics = () => {
    const isTestEnv = isTestEnvironment(document.domain);
    const analytics = new ApplicationInsights();
    const config = {
      instrumentationKey: '8446ded5ecdb4f3e8f519ec050bf34f6-6edab109-790e-45f5-bb6e-a98c950a8fcb-7425',
      channelConfiguration: { // Post channel configuration
        eventsLimitInMem: 5000,
      },
      propertyConfiguration: { // Properties Plug in configuration
        gpcDataSharingOptIn: typeof gpcDataSharingOptIn !== 'undefined' ? gpcDataSharingOptIn : true,
        callback: {
          userConsentDetails: window.WcpConsent.siteConsent ? window.WcpConsent.siteConsent.getConsent : undefined,
        },
        env: isTestEnv ? 'PPE' : 'PROD', // Environment can be set to PPE or PROD as needed.
      },
      webAnalyticsConfiguration: { // Web Analytics Plugin configuration
        autoCapture: {
          scroll: true,
          pageView: true,
          onLoad: true,
          onUnload: true,
          click: true,
          resize: true,
          jsError: true,
        },
        autoPopulateParentIdAndParentName: true,
        useDefaultContentName: true,
        useShortNameForContentBlob: true,
        urlCollectHash: true,
        urlCollectQuery: true,
        isLoggedIn: false,
        shareAuthStatus: true,
      },
    };
    // Initialize SDK
    analytics.initialize(config, []);
    analytics.getPropertyManager().getPropertiesContext().web.gpcDataSharingOptIn
      = gpcDataSharingOptIn;
    analytics.getPropertyManager().core.config.extensionConfig.SystemPropertiesCollector.gpcDataSharingOptIn
      = gpcDataSharingOptIn;
  };

  const initAdobeTracking = () => {
    const trackingScriptUrl = _.chain(serverContext)
      .result('ThirdPartConfig')
      .result('AdobeTrackingScriptUrl', undefined)
      .value();
    if (!_.isUndefined(trackingScriptUrl) && _.isFunction($.getScript)) {
      $.ajax({
        url: trackingScriptUrl,
        dataType: 'script',
        crossOrigin: true,
        credentials: 'omit',
        success: () => initPDL(serverContext),
      });
    }
  };

  window.addEventListener('load', () => {
    // GPC consent and WCP consent are required for 1DS analytics
    // we don't need any consent condition because the consent information is passed in oneDS calls
    if (window.WcpConsent && window.WcpConsent.siteConsent) {
      init1DSAnalytics();
      initAdobeTracking();
    }
  });
}
